export default __webpack_public_path__ + "static/media/宠帮运勋章@2x.1df2102f.png";